import { IBaseEntity } from './base';

export interface IImage extends IBaseEntity {
  name: string;
  folderId: number;
  width: number;
  height: number;
  orientation: Orientation;
  rotation: number;
}

export interface IImageDAO extends IImage {
  files: IImageFile[];
}

export interface IImageFile extends IBaseEntity {
  imageId: number;
  resourceId: number;
  order: number;
  filename: string;
  resolution: number;
}

export enum Orientation {
  LANDSCAPE = 0,
  PORTRAIT = 1,
}

export enum Resolutions {
  XSMALL_256 = 0,
  SMALL_512 = 1,
  MED_1024 = 2,
  FULL_2048 = 3,
  MAX_4096 = 4,
}

export enum ImageFileType {
  WEBP = 0,
  JPG = 1,
  PNG = 2,
}
